import { useEffect } from "react";

const SUPPORTED = ["nl", "en", "hu"];

/**
 * Injects hreflang alternate tags into <head> based on the current pathname.
 * Idempotent — removes previous tags before inserting.
 */
export default function useHreflangTags() {
  useEffect(() => {
    const inject = () => {
      const existing = document.querySelectorAll('link[rel="alternate"][data-i18n-hreflang]');
      existing.forEach((n) => n.remove());
      const origin = window.location.origin;
      const rest = window.location.pathname.replace(/^\/(nl|en|hu)(?=\/|$)/, "") || "";
      SUPPORTED.forEach((code) => {
        const link = document.createElement("link");
        link.rel = "alternate";
        link.hreflang = code;
        link.href = `${origin}/${code}${rest}`;
        link.setAttribute("data-i18n-hreflang", "true");
        document.head.appendChild(link);
      });
      const xd = document.createElement("link");
      xd.rel = "alternate";
      xd.hreflang = "x-default";
      xd.href = `${origin}/nl${rest}`;
      xd.setAttribute("data-i18n-hreflang", "true");
      document.head.appendChild(xd);
    };
    inject();
  }, []);
}
